import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, Subscription } from 'rxjs';

import { AnalyticsService } from '../../service/analytics.service';

type DropdownKey = 'contatti' | 'servizi' | null;

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.scss'],
})
export class NavbarComponent {
  // ✅ stato menu mobile (collapse)
  isMenuOpen = false;

  // ✅ stato dropdown
  openDropdown: DropdownKey = null;

  private sub?: Subscription;

  constructor(
    private router: Router,
    private analytics: AnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // ✅ chiudi sempre su cambio rotta
    this.sub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => this.closeAll());
  }

  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (!this.isMenuOpen) this.openDropdown = null;
  }

  toggleDropdown(key: Exclude<DropdownKey, null>, event: MouseEvent): void {
    // non navigare: serve ad aprire/chiudere il dropdown
    event.preventDefault();
    event.stopPropagation();

    // se il menu mobile è chiuso, su desktop funziona uguale
    this.openDropdown = this.openDropdown === key ? null : key;
  }

  closeAll(): void {
    this.isMenuOpen = false;
    this.openDropdown = null;
  }

  closeNavbar(): void {
    // chiamata dai click sui link: chiude tutto
    this.closeAll();
  }

  // ✅ click fuori: chiude dropdown (e se vuoi anche menu mobile)
  @HostListener('document:click', ['$event'])
  onDocumentClick(_: MouseEvent): void {
    if (!this.isBrowser) return;
    this.openDropdown = null;
  }

  // ✅ evita che il click dentro la navbar chiuda il dropdown (stop propagation)
  onNavClick(event: MouseEvent): void {
    event.stopPropagation();
    const target = event.target;
    if (!(target instanceof Element)) return;
    const href = target.closest('a')?.getAttribute('href') || '';
    // Navigation stops bubbling, so its contact links must be tracked here.
    if (href.startsWith('tel:')) this.analytics.trackContact('phone');
    else if (/^https:\/\/(wa\.me|api\.whatsapp\.com)(\/|$)/.test(href)) {
      this.analytics.trackContact('whatsapp');
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
